import { FilterFilled } from '@ant-design/icons';
import { Table } from 'antd';
import styled from 'styled-components';

function validateColumns(columns) {
	if (!Array.isArray(columns)) {
		throw new Error('Columns prop must be an array');
	}
	columns.forEach((col, idx) => {
		if (!col.filterSorterNotRequired && !col.sorter) {
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// Notification('error', `Column at ${col.key} is missing a 'sorter' property`);
		}
		if (!col.filterSorterNotRequired && !col.filterDropdown) {
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// ! enable this once the new table rollout is done
			// Notification('error', `Column at ${col.key} is missing a 'filterDropdown' property`);
		}
		if (col.disableFilter) {
			col.filterDropdown = () => null;
			col.filterIcon = <FilterFilled style={{ color: '#ACACAC', cursor: 'not-allowed' }} />;
		}
	});
}

const ValidatedTable = (props) => {
	validateColumns(props.columns);
	return <Table {...props} />;
};

const StyledTable = styled(ValidatedTable)`
	// Add your styles here

	.ant-table-tbody > tr > td {
		border-bottom: none;
	}
`;

export default StyledTable;
